import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Result() {
  return (
    <section className="result_par result_chat p-100 text_chat">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto resp_order"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/our-chat/Results.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={722}
                height={698}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              The <span>Results</span>
            </h2>
            <p>
              The client wanted to create an affordable and easy-to-use platform
              for users to connect with professionals. We used the best digital
              solutions and practices to turn their vision into reality in the
              form of an app that is convenient, offers great accessibility,
              while generating revenue at the same time.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/ca/app/ourchat-inc/id6444663778">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.ourchat&hl=en_US">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Result;
